export default __webpack_public_path__ + "static/media/GHSI Corporate Governance Charter.ea3d685c.pdf";